/** Feedback-Dialog und Ticket-Gespräch (FeedbackWidget, FeedbackThread). */
const feedbackDE: Record<string, string> = {
  fbTitle: 'Feedback geben',
  fbTabNew: 'Neues Feedback',
  fbTabMine: 'Meine Tickets',
  fbLoading: 'Wird geladen…',
  fbNoTickets: 'Du hast noch kein Feedback gesendet.',
  fbStatusDone: 'Erledigt',
  fbStatusInProgress: 'In Arbeit',
  fbStatusOpen: 'Offen',
  fbIntro: 'Hilf uns, SAIA besser zu machen. Du kannst einen Screenshot der aktuellen Seite anhängen.',
  fbFieldTitle: 'Titel',
  fbFieldTitlePlaceholder: 'Kurze Zusammenfassung deines Feedbacks',
  fbFieldDescription: 'Beschreibung',
  fbFieldDescriptionPlaceholder: 'Beschreibe dein Feedback möglichst genau …',
  fbScreenshotOptional: 'Screenshot (optional)',
  fbScreenshotPreview: 'Screenshot-Vorschau',
  fbScreenshotCapture: 'Tippe, um einen Screenshot aufzunehmen',
  fbScreenshotRecapture: 'Neu aufnehmen',
  fbScreenshotRemove: 'Entfernen',
  fbCancel: 'Abbrechen',
  fbSubmit: 'Feedback senden',
  fbSubmitting: 'Wird gesendet …',
  fbSuccess: 'Danke! Dein Feedback ist bei uns angekommen.',
  fbErrorLoadTickets: 'Deine Tickets konnten nicht geladen werden.',
  fbErrorScreenshot: 'Der Screenshot hat nicht geklappt. Du kannst das Feedback trotzdem ohne Screenshot senden.',
  fbErrorRequired: 'Bitte fülle Titel und Beschreibung aus.',
  fbErrorSubmit: 'Feedback konnte nicht gesendet werden. Bitte versuche es erneut.',
  fbAuthorYou: 'Du',
  fbAuthorTeam: 'SAIA Team',
  fbAuthorReporter: 'Melder',
  fbOriginalReport: 'Ursprüngliche Meldung',
  fbReplyPlaceholder: 'Antwort schreiben…',
  fbReplySend: 'Antwort senden',
  fbReplyError: 'Antwort konnte nicht gesendet werden. Bitte erneut versuchen.',
};

export default feedbackDE;
